import { confirmDialog } from "primereact/confirmdialog";
import { Ripple } from "primereact/ripple";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { userProfile } from "../Api/UserData";
import { useAuth } from "../Authentication/AuthContext";
import InfoModal from "../Components/InfoModal";

interface NavbarProps {
    isOpen?: boolean;
    toggleSidebar?: () => void;
    showToggle?: boolean;
    toggleButton?: React.RefObject<HTMLButtonElement>;
}

const Navbar: React.FC<NavbarProps> = ({ isOpen, toggleSidebar, toggleButton, showToggle }) => {
    const navigate = useNavigate();

    const [userData, setUserData] = useState<any>([]);

    const path: string = window.location.pathname;

    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
    const profileMenuRef = useRef<HTMLDivElement>(null);
    const profileButtonRef = useRef<HTMLButtonElement>(null);

    const { logout, isAuthenticated } = useAuth();

    const handleLogOut = () => {
        setIsMenuOpen(prevState => !prevState);
        logout();
    };

    const accept = () => {
        /* ***** remove local storage data  *******/
        if (localStorage.getItem('token')) {
            localStorage.removeItem('token');
        }
        if (localStorage.getItem('user_id')) {
            localStorage.removeItem('user_id');
        }
        if (localStorage.getItem('user_type_id')) {
            localStorage.removeItem('user_type_id');
        }
        if (localStorage.getItem('user_type_name')) {
            localStorage.removeItem('user_type_name');
        }
        if (localStorage.getItem('company_name')) {
            localStorage.removeItem('company_name');
        }
        if (localStorage.getItem('currency_symbol')) {
            localStorage.removeItem('currency_symbol');
        }
        if (localStorage.getItem('material_tax_percentage')) {
            localStorage.removeItem('material_tax_percentage');
        }
        if (localStorage.getItem('vat_percentage')) {
            localStorage.removeItem('vat_percentage');
        }
        /* ***** remove local storage data  *******/

        navigate('/');
    }

    const toggleProfileMenu = () => {
        setIsMenuOpen(prevState => !prevState);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (
            profileMenuRef.current &&
            !profileMenuRef.current.contains(event.target as Node) &&
            profileButtonRef.current &&
            !profileButtonRef.current.contains(event.target as Node)
        ) {
            setIsMenuOpen(false);
        }
    };

    /* ************************************* profile data - start ************************************ */
    const profileData = async () => {
        if (localStorage.getItem('user_id') && localStorage.getItem('token')) {
            const data = await userProfile(localStorage.getItem('token') || '');
            if (data.status) {
                setUserData(data.userData);
            }
        }
    }

    const newtWorkError = () => {
        if (!(path === "/auth/login" || path === "/auth/signup" || path === "/auth/forgot-password")) {
            confirmDialog({
                message: 'Network error, login again!',
                header: 'Network Error',
                icon: 'bi bi-info-circle',
                defaultFocus: 'accept',
                acceptClassName: 'p-button-danger',
                rejectClassName: 'd-none',
                acceptLabel: 'Ok',
                accept,
            });
        }

    }
    /* ************************************* profile data - end ************************************ */

    useEffect(() => {
        profileData();
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const [showInfoModal, setShowInfoModal] = useState<boolean>(false);

    const handleShowInfoModal = () => {
        setShowInfoModal(true);
    }

    const handleCloseInfoModal = () => {
        setShowInfoModal(false);
    }

    return (
        <React.Fragment>
            <nav className={`nav_bar ${isOpen ? 'menu_toggled' : ''}`}>
                <div className="container-fluid">
                    <div className="nav_item_list">
                        <div className="nav_item_left">
                            <Link to={'/dash-board'} className="nav_logo_link">
                                <img src="/assets/images/traqdo_logo.svg" alt="Traqdo" className="nav_logo" />
                            </Link>
                        </div>
                        {isAuthenticated && userData && (
                            <div className="nav_item_right">
                                <ul className="nav_items">
                                    {showToggle && (
                                        <li className="nav_item nav_toggle_area">
                                            <button className={`nav_toggle p-ripple ${isOpen ? 'toggled' : ''}`} onClick={toggleSidebar} ref={toggleButton}>
                                                <i className={`bi ${isOpen ? 'bi-arrow-right' : 'bi-list'}`}></i>
                                                <Ripple />
                                            </button>
                                        </li>
                                    )}

                                    <li className="nav_item nav_profile_toggle">
                                        <button className={`nav_profile_toggle_btn ${isMenuOpen ? 'toggled' : ''} p-ripple`}
                                            onClick={toggleProfileMenu}
                                            ref={profileButtonRef}>
                                            <div className="nav_profile_img_area">
                                                {/* Profile has image */}
                                                {/* <img src="/assets/images/sample_images/sample_profile_img.png" className="nav_profile_img" alt="Profile" /> */}

                                                {/* Profile hasn't image */}
                                                <img src="/assets/images/user.png" className="nav_profile_icon" alt="Profile" />
                                            </div>

                                            <div className="nav_profile_info_area">
                                                <h6>Hello,&nbsp;
                                                    <span className="text-capitalize">{userData.first_name ? userData.first_name : ''}</span>
                                                </h6>
                                                <p className="text-capitalize">{userData.type_name ? userData.type_name : ''}</p>
                                            </div>
                                            <i className="bi bi-chevron-down toggle_icon"></i>

                                            <Ripple />
                                        </button>

                                        <div className={`profile_toggle_menu ${isMenuOpen ? 'show' : ''}`} ref={profileMenuRef}>
                                            <ul className="profile_toggle_menu_list">
                                                <li className="profile_toggle_menu_item">
                                                    <Link to={'/my-profile'} className="profile_toggle_menu_link p-ripple" onClick={toggleProfileMenu}>
                                                        <i className="bi bi-person"></i>
                                                        <span>My profile</span>
                                                        <Ripple />
                                                    </Link>
                                                </li>
                                                <li className="profile_toggle_menu_item">
                                                    <Link
                                                        to={'/settings'}
                                                        // to={'#'}
                                                        className="profile_toggle_menu_link p-ripple"
                                                        onClick={() => {
                                                            toggleProfileMenu();
                                                            // handleShowInfoModal();
                                                        }}
                                                    >
                                                        <i className="bi bi-gear"></i>
                                                        <span>Settings</span>
                                                        <Ripple />
                                                    </Link>
                                                </li>

                                                <li className="profile_toggle_menu_item">
                                                    <button onClick={handleLogOut} className="profile_toggle_menu_link danger p-ripple">
                                                        <i className="bi bi-box-arrow-right"></i>
                                                        <span>Sign Out</span>
                                                        <Ripple />
                                                    </button>
                                                </li>

                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </nav>

            <InfoModal
                show={showInfoModal}
                onClose={handleCloseInfoModal}
                title="Stay Tuned!"
                info="This feature is currently under development on the web and will be available soon."
                showAppLink={false}
            />
        </React.Fragment>
    );
};

export default Navbar;